import { KU_TOP_100 } from '../../../core/constants';
import BookstatListTab from './BookstatListTab';
import { acquisitionRowActions } from './digestRowActions';

const renderActions = acquisitionRowActions(KU_TOP_100);

const KuTop100 = () => <BookstatListTab id={KU_TOP_100} renderActions={renderActions} />;

export default KuTop100;
